import React, { useMemo } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';

const BasketballMatchGameBoxScore = observer(({ item }) => {
  const {
    getTracker,
    period,
    sortedAwayScores,
    sortedHomeScores,
    quarterArr
  } = item;
  const homeTotalScore = sortedHomeScores.reduce((a, b) => a + b.score, 0);
  const awayTotalScore = sortedAwayScores.reduce((a, b) => a + b.score, 0);
  const overTimeScore = useMemo(() => {
    const result = {
      home: '-',
      away: '-'
    };

    if (period > 4) {
      const homeScoreArr = sortedHomeScores.filter((score) => score.period > 4);

      if (homeScoreArr.length > 0) {
        result.home = homeScoreArr.reduce((a, c) => a + c.score, 0);
      }

      const awayScoreArr = sortedAwayScores.filter((score) => score.period > 4);

      if (awayScoreArr.length > 0) {
        result.away = awayScoreArr.reduce((a, c) => a + c.score, 0);
      }
    }

    return result;
  }, [period, sortedHomeScores, sortedAwayScores]);

  return (
    <div className={clsx('basic_board')}>
      {quarterArr.map((quarter, idx) => {
        if (quarter.value > 4) {
          return null;
        } else {
          return (
            <dl
              className={clsx(
                'item',
                getTracker.status === 'progress' &&
                  period === quarter.value &&
                  'on'
              )}
              key={`box-item-${quarter.value}`}
            >
              <dt>{quarter.key}</dt>
              <dd>{!!sortedAwayScores[idx] && sortedAwayScores[idx].score}</dd>
              <dd>{!!sortedHomeScores[idx] && sortedHomeScores[idx].score}</dd>
            </dl>
          );
        }
      })}
      {period > 4 && (
        <dl className="item">
          <dt>연장</dt>
          <dd>{overTimeScore.away}</dd>
          <dd>{overTimeScore.home}</dd>
        </dl>
      )}
      <dl className="item r">
        <dt>합계</dt>
        <dd>{awayTotalScore}</dd>
        <dd>{homeTotalScore}</dd>
      </dl>
    </div>
  );
});

export default BasketballMatchGameBoxScore;
